import * as React from "react";
const SvgFileGrid20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 1h-.414l-.293.293-6 6L3 7.586V19h5.5v-2H5V9h6V3h4v6.5h2V1h-7ZM9 7H6.414L9 4.414V7Zm2 4.5h-.5v8h8v-8H11Zm.5 3.5v-2.5H14V15h-2.5Zm3.5 0v-2.5h2.5V15H15Zm0 1h2.5v2.5H15V16Zm-1 0v2.5h-2.5V16H14Z",
      clipRule: "evenodd"
    })
  );
export default SvgFileGrid20Px;
